import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack
} from '@mui/material';
import {
  Business,
  CheckCircle,
  Schedule,
  Security,
  Groups,
  Computer,
  LocalShipping
} from '@mui/icons-material';

function BusinessMove() {
  const benefits = [
    {
      icon: <Schedule sx={{ fontSize: 30, color: '#55d6dc' }} />,
      title: 'Minimale Ausfallzeiten',
      description: 'Wir planen Ihren Umzug so, dass Ihr Geschäftsbetrieb minimal beeinträchtigt wird.'
    },
    {
      icon: <Security sx={{ fontSize: 30, color: '#55d6dc' }} />,
      title: 'Sicherheit & Versicherung',
      description: 'Vollständiger Versicherungsschutz für Ihre IT-Ausstattung und Büroeinrichtung.'
    },
    {
      icon: <Groups sx={{ fontSize: 30, color: '#55d6dc' }} />,
      title: 'Erfahrenes Team',
      description: 'Spezialisierte Mitarbeiter für Büro- und Firmenumzüge mit langjähriger Erfahrung.'
    },
    {
      icon: <Computer sx={{ fontSize: 30, color: '#55d6dc' }} />,
      title: 'IT-Kompetenz',
      description: 'Fachgerechter Umgang mit Servern, Computern und sensibler Technik.'
    }
  ];

  const services = [
    'Komplette Umzugsplanung und -koordination',
    'Demontage und Montage von Büromöbeln',
    'Sicherer Transport von IT-Equipment',
    'Verpackung von Akten und Dokumenten',
    'Einrichtung am neuen Standort',
    'Entsorgung nicht benötigter Gegenstände',
    'Wochenend- und Nachtumzüge möglich',
    'Zwischenlagerung bei Bedarf'
  ];

  return (
    <Box sx={{ 
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0a1f28 0%, #162a34 50%, #1c3440 100%)'
    }}>
      <Container maxWidth="lg" sx={{ pt: 12, pb: 6 }}>
        {/* Hero Section */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Business sx={{ fontSize: 80, color: '#55d6dc', mb: 3 }} />
          <Typography variant="h2" sx={{ color: 'white', fontWeight: 'bold', mb: 3 }}>
            Firmenumzug
          </Typography>
          <Typography variant="h5" sx={{ color: '#55d6dc', mb: 2 }}>
            Professionelle Büro- und Firmenumzüge
          </Typography>
          <Typography variant="body1" sx={{ color: 'white', opacity: 0.9, maxWidth: 800, mx: 'auto' }}>
            Minimale Ausfallzeiten, maximale Effizienz. Wir sorgen dafür, dass Ihr Unternehmen 
            schnell wieder voll einsatzfähig ist.
          </Typography>
        </Box>

        {/* Benefits Grid */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Paper
                sx={{
                  p: 3,
                  bgcolor: '#1a3a44',
                  borderRadius: 2,
                  border: '1px solid rgba(255,255,255,0.08)',
                  height: '100%',
                  transition: 'transform 0.3s ease, border-color 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    borderColor: '#55d6dc'
                  }
                }}
              >
                <Stack direction="row" spacing={2} alignItems="flex-start">
                  <Box sx={{ 
                    bgcolor: 'rgba(85,214,220,0.12)', 
                    borderRadius: '50%', 
                    p: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {benefit.icon}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" sx={{ color: 'white', mb: 1, fontWeight: 'bold' }}>
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'white', opacity: 0.85 }}>
                      {benefit.description}
                    </Typography>
                  </Box>
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Services Section */}
        <Card sx={{ 
          bgcolor: 'rgba(255,255,255,0.05)', 
          backdropFilter: 'blur(10px)',
          mb: 6
        }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h4" sx={{ color: 'white', mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
              Unsere Leistungen für Firmenumzüge
            </Typography>
            <Grid container spacing={2}>
              {services.map((service, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircle sx={{ color: '#55d6dc' }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary={service}
                      sx={{ color: 'white' }}
                    />
                  </ListItem>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        {/* CTA Section */}
        <Box sx={{ 
          bgcolor: '#275664', 
          borderRadius: 3,
          p: 4,
          textAlign: 'center'
        }}>
          <LocalShipping sx={{ fontSize: 60, color: '#ffd700', mb: 2 }} />
          <Typography variant="h4" sx={{ color: 'white', mb: 2, fontWeight: 'bold' }}>
            Planen Sie Ihren Firmenumzug mit uns
          </Typography>
          <Typography variant="body1" sx={{ color: 'white', opacity: 0.9, mb: 3 }}>
            Kostenlose Beratung und unverbindliches Angebot für Ihren Büroumzug
          </Typography>
          <Box
            component="button"
            onClick={() => window.location.href = '/contact'}
            style={{
              backgroundColor: '#55d6dc',
              color: '#275664',
              padding: '12px 32px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer'
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#4bc2c8')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#55d6dc')}
          >
            Jetzt Angebot anfordern
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default BusinessMove;